import ResourceLink from 'components/common/digitalResourcesMaps/resourceLink';
import React, { useCallback } from 'react';
import { IDResource, MapGroupProps } from 'types';
import { getPictureByUrl, onFaviconError } from 'utils/helpers/resourcesMap';

const TechnologySkillsLink: React.FC<MapGroupProps> = ({
  resources,
  onHoveredElementChanged,
  onClick,
}) => {
  const onElementHover = useCallback(
    (resource?: IDResource, target?: SVGElement) => {
      if (onHoveredElementChanged) {
        onHoveredElementChanged(resource, target);
      }
    },
    [onHoveredElementChanged]
  );

  const resource1SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="18.72"
        y="32.56"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(-19.49 21.98) rotate(-19.93)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(17 50) rotate(-19.93)"
        href={getPictureByUrl(resources[0]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource2SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="109.49"
        y="15.42"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(0.2 -0.59) rotate(0.23)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(115.5 21) rotate(0.23)"
        href={getPictureByUrl(resources[1]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource3SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="210.49"
        y="19.42"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(0.22 -1) rotate(0.23)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(217 25) rotate(0.23)"
        href={getPictureByUrl(resources[2]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource4SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="9.72"
        y="116.56"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(-48.67 23.94) rotate(-19.93)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(8 134) rotate(-19.93)"
        href={getPictureByUrl(resources[3]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );
  const resource5SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="99.47"
        y="104.44"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(12.24 -10.85) rotate(4.87)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(108 108) rotate(4.87)"
        href={getPictureByUrl(resources[4]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  const resource6SVGComponent = (
    <g className="icon-link" pointerEvents="none">
      <rect
        x="189.63"
        y="109.14"
        width="68.16"
        height="67.8"
        rx="12.87"
        transform="translate(12.96 -18.49) rotate(4.87)"
        fill="#fff"
        stroke="#fff205"
        strokeMiterlimit="10"
        strokeWidth="4"
      />
      <image
        width="56"
        height="56"
        transform="translate(198.5 113) rotate(4.87)"
        href={getPictureByUrl(resources[5]?.link)}
        onError={onFaviconError}
        pointerEvents="all"
      />
    </g>
  );

  return (
    <g
      className="digital-resources-technology-skills"
      transform="translate(780, 210)"
    >
      <defs>
        <linearGradient
          id="a444237c-ab1b-4076-9255-44be4c71c26e"
          x1="113.12"
          y1="199.66"
          x2="108.4"
          y2="375.11"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stopColor="#663d3c" />
          <stop offset="0.01" stopColor="#663d3c" />
          <stop offset="0.32" stopColor="#794545" />
          <stop offset="0.64" stopColor="#834a4a" />
          <stop offset="1" stopColor="#874c4c" />
        </linearGradient>
        <linearGradient
          id="af7e6268-7007-497a-8ece-16f69e9d9fce"
          x1="236.19"
          y1="238.12"
          x2="200.13"
          y2="651.01"
          href="#a444237c-ab1b-4076-9255-44be4c71c26e"
        />
        <linearGradient
          id="b9182596-b83a-4f8d-8970-5fe7f337146c"
          x1="317.95"
          y1="248.9"
          x2="287.45"
          y2="598.15"
          href="#a444237c-ab1b-4076-9255-44be4c71c26e"
        />
        <linearGradient
          id="e3556062-ecd6-426e-9982-a26eedcc2b41"
          x1="184.6"
          y1="334.07"
          x2="178.95"
          y2="398.81"
          href="#a444237c-ab1b-4076-9255-44be4c71c26e"
        />
        <linearGradient
          id="be7dc9d2-26c6-456b-9656-de83e69db48b"
          x1="210.11"
          y1="351.29"
          x2="202.59"
          y2="437.4"
          href="#a444237c-ab1b-4076-9255-44be4c71c26e"
        />
      </defs>
      <g id="ba5cc66c-c2f3-4688-890f-38175d919aa9" data-name="island3">
        <g>
          <path
            d="M9.08,189.39s34.66,59.38,54.08,86.4c6.51,9,13-7.55,13.7-4.72.61,2.4,8.2,19.77,15.15,25,14.39,10.78,39.67,30.38,57,29.7a95.84,95.84,0,0,1,22.66,17.46s79,71.56,87.12,70.54,11.18-24.38,11.18-24.38,9.27,6.68,19.31,5.08c8.06-1.29,19.7-15.88,31.5-22.36,27.5-15.11,57.47-28.3,56.65-28.08l39.88-24.32,20.19-35.11s50.47-90.76,49.77-93.84-30.82-50.87-30.82-50.87l-94.79,108s17.89,47.92,13.65,48.94S248.27,273.23,237,265s-5.64-15.38-5.64-15.38-24-10.26-43.75-11.29-36-30.77-48.69-41-33.87-4.1-50.1,4.11-32.46,2-31-7.18S9.08,189.39,9.08,189.39Z"
            fill="#874c4c"
          />
          <path
            d="M87.68,224.48c11.54-6.07,19.47-8.77,28.13,2s10.1,84.39,18,93.84c5,5.4-15.87,1.35-31-18.9S87.68,224.48,87.68,224.48Z"
            fill="url(#a444237c-ab1b-4076-9255-44be4c71c26e)"
          />
          <path
            d="M183.56,303c16.26-21.34,45.18,9.28,45.18,9.28s33.63,71,41.2,77.1C260.79,454.4,183.56,303,183.56,303Z"
            fill="url(#af7e6268-7007-497a-8ece-16f69e9d9fce)"
          />
          <path
            d="M300.42,387.33c-5.08-18.29-13-83.86-13-83.86L339,302Z"
            fill="url(#b9182596-b83a-4f8d-8970-5fe7f337146c)"
          />
          <path
            d="M117.7,246.47c-.39-4.45.14-9-1.2-13.32-4.4-14.09-20.9-9.1-36.1-2.85-7.63,3.13-20.26-1-28.32,1.17s-18.69.2-21.6-6.67c-1-2.35-.94-5-1.76-7.35-1.68-5-6.72-8.38-10.65-12.26C10.43,197.65,6.62,187.83,3,178.3,1.39,174-.25,169.65,0,165.17c.73-11.45,13.15-19.3,24.33-25.41,20.24-11.07,2.72-22.81,23-33.88,23.83-13,93.29-9,121.33-11.37C199.46,92,223,86.45,253.89,87c28,.51,56.6-7.64,83.54-1,10.57,2.6,67.18,8.34,76.73,13.06,21.84,10.78,43.06,16.52,64.9,27.3,13.86,6.85-18,17.91-2.09,19,5.18.34,10.64.08,15.27,2.13,8.4,3.73,10.53,13.52,8.87,21.58s-6,15.66-6.69,23.83c-.27,3.23,0,6.67-1.88,9.47-4.94,7.42-21.2,5.78-23.4,14.13-.84,3.22,1,6.86-.75,9.78-2.84,4.65-13.66,7.48-9.55,11.36,1,.92,2.51,1.16,3.82,1.69,7.22,2.9,4.49,13.43-2.73,16.34s-15.63.9-23.34-.82-16.64-2.87-23,1.29c-3.5,2.29-6,6.09-10.25,6.95-2.58.52-5.26-.18-7.9-.12-9.64.24-14.87,9.65-17.94,17.57l43.31,9.2c5.57,1.18,8,7.37-4.43,10.88s-25.84,3.62-39,3.69c-58.08.34-118.43,4.81-176.27.09C168,301.67,120.56,278.36,117.7,246.47Z"
            fill="#68c902"
          />
          <path
            d="M121.94,233.88c-12.72-5.41-18-1.74-14.6,1.41S137.81,240.63,121.94,233.88Z"
            fill="#68c902"
          />
          <path
            d="M43.58,235.85l.63-1.42c.67,2,4.32,2,5.07.09.95,1.56,2.84,3.37,4.42,2.36.43-.28.71-.72,1.13-1,1.37-1,3.32.09,4.46,1.29s2.3,2.71,4,2.76a7.34,7.34,0,0,0,.84-5.52A19,19,0,0,0,69,237.7a15.12,15.12,0,0,0,1.13-4.11c1,2.23,4.53,1.71,6.94.82l10.15-3.73A42.8,42.8,0,0,1,92,240.62c-1-4.5-1.51-10.07,2.42-12.8a45.22,45.22,0,0,0,.81,9.64c6.14-5.54,5.93-14.63,5.28-22.59a108.69,108.69,0,0,0-10.74,3.23c-6.62,2-13.54,3.07-20.43,4.08l-23.91,3.54c-2.51.36-7.39.18-7.9,3.29C37.18,230.86,41.58,235.85,43.58,235.85Z"
            fill="#68c902"
          />
          <ellipse
            cx="304.04"
            cy="284.01"
            rx="34.62"
            ry="8.44"
            fill="#54ba02"
          />
          <path
            d="M304,275.57c-16.69,0-30.62,2.88-33.89,6.71,5.91-2.59,17.25-4.35,30.29-4.35,19.11,0,34.61,3.78,34.61,8.44a2.66,2.66,0,0,1-.72,1.72c2.75-1.21,4.33-2.6,4.33-4.08C338.66,279.35,323.16,275.57,304,275.57Z"
            fill="#4fb002"
          />
          <ellipse
            cx="418.56"
            cy="151.35"
            rx="34.62"
            ry="8.44"
            fill="#54ba02"
          />
          <path
            d="M418.56,142.91c-16.69,0-30.62,2.89-33.89,6.72,5.91-2.6,17.25-4.35,30.29-4.35,19.12,0,34.61,3.78,34.61,8.44a2.68,2.68,0,0,1-.72,1.72c2.75-1.21,4.33-2.6,4.33-4.09C453.18,146.69,437.68,142.91,418.56,142.91Z"
            fill="#4fb002"
          />
          <ellipse cx="57.75" cy="194.25" rx="34.62" ry="8.44" fill="#54ba02" />
          <path
            d="M57.75,185.81c-16.69,0-30.62,2.88-33.89,6.71,5.9-2.59,17.25-4.35,30.28-4.35,19.12,0,34.62,3.78,34.62,8.44a2.7,2.7,0,0,1-.72,1.73c2.75-1.22,4.33-2.61,4.33-4.09C92.37,189.59,76.87,185.81,57.75,185.81Z"
            fill="#4fb002"
          />
          <ellipse cx="178" cy="239.1" rx="31.61" ry="7.71" fill="#54ba02" />
          <path
            d="M178,231.4c-15.24,0-28,2.63-30.95,6.13,5.39-2.37,15.75-4,27.65-4,17.46,0,31.61,3.45,31.61,7.71a2.42,2.42,0,0,1-.66,1.57c2.52-1.1,3.95-2.37,3.95-3.73C209.6,234.85,195.45,231.4,178,231.4Z"
            fill="#4fb002"
          />
          <ellipse
            cx="248.27"
            cy="292.78"
            rx="19.85"
            ry="4.84"
            fill="#54ba02"
          />
          <path
            d="M248.27,288c-9.57,0-17.56,1.65-19.43,3.84,3.38-1.48,9.89-2.49,17.36-2.49,11,0,19.85,2.17,19.85,4.84a1.55,1.55,0,0,1-.42,1c1.58-.7,2.49-1.5,2.49-2.35C268.12,290.11,259.23,288,248.27,288Z"
            fill="#4fb002"
          />
          <ellipse
            cx="416.07"
            cy="232.47"
            rx="24.04"
            ry="5.86"
            fill="#54ba02"
          />
          <path
            d="M416.07,226.61c-11.6,0-21.27,2-23.54,4.67,4.1-1.81,12-3,21-3,13.28,0,24,2.63,24,5.86a1.84,1.84,0,0,1-.5,1.2c1.91-.84,3-1.81,3-2.84C440.11,229.24,429.34,226.61,416.07,226.61Z"
            fill="#4fb002"
          />
          <ellipse
            cx="379.71"
            cy="225.89"
            rx="12.69"
            ry="3.09"
            fill="#54ba02"
          />
          <path
            d="M379.71,222.8c-6.12,0-11.23,1-12.43,2.46,2.17-.95,6.33-1.6,11.1-1.6,7,0,12.7,1.39,12.7,3.1a1,1,0,0,1-.27.63c1-.44,1.59-1,1.59-1.5C392.4,224.18,386.72,222.8,379.71,222.8Z"
            fill="#4fb002"
          />
          <path
            d="M74.4,253.68s-10.1-.45-11.78,1.13-11.06.45-11.06.45l-1.44-5.4A63.35,63.35,0,0,0,46,255c-.24.68-1.2,3.6-1.2,3.6L47,265.39l1.44-5.18,3.6.9a25.77,25.77,0,0,1,1,3.6c0,.68,1.92-3.83,1.92-3.83L58.05,262l1.21-2.7,2.4,1.57.72,4.73,2.16-7.2L66.23,260l1.44-2.47,2.16-1.13Z"
            fill="#45a102"
          />
          <path
            d="M233.63,324.91l4.49,3.07,9,.24L268,326.09s-7.94,3.78-8.67,4-13.87,1-13.87,1L242,334.61l-1.89-3.37-1.77-.31-1,4.61-2.17-5.49L231.86,332l-.48-3.55Z"
            fill="#45a102"
          />
          <path
            d="M246.52,304c6.53,1.48,14.76-.75,21.46-.4,4.88.26,8.48-.33,13.34-.67,34.13-2.42,67.87-.87,102-3.29,7.19-.51,14.48-1,21.57.22,1.69.29,3.82,1.34,3.36,2.89-.34,1.15-1.87,1.5-3.13,1.64l-21.76,2.5a7.94,7.94,0,0,1-4.17,7.17,23.1,23.1,0,0,0,.19-7.14c-4,1-8.21.93-12.36.83l-2.91-.07-17.59-.44L348,310a37.37,37.37,0,0,0-24-.72,50.12,50.12,0,0,1,11.28,4.06,41.66,41.66,0,0,1-23.2-4.59,7.67,7.67,0,0,1-8.11,1.36c-2.71,2.66-8.11,2-10.06-1.14l-1,12.12a27.8,27.8,0,0,1-5.32-13.5,8.09,8.09,0,0,1-8.42,2.14,34.29,34.29,0,0,1-21.51-1.17c-4.46-1.73-8.05-4.75-12.85-5.69-7.17-1.39-15,.57-22.35-.08A165.84,165.84,0,0,1,200.87,299c-10-2.26-24.09-7.24-34.35-4.92.35,3.26,3.18,6.21,6.35,7.5,1.21.49,3.21.31,3.15-.92.7,1.69,1.54,3.52,3.26,4.35s4.44-.19,4.24-2c4.29,3.53,10.94,5.25,15.78,2.4,1.94,3.07,6.87,4,9.95,1.91l4.48,8.57a29.18,29.18,0,0,0,4.55-9.51c1,2.19,4.42,3,6.34,1.42,1.92,2.93,5.93,4.18,9.59,3.93s7.09-1.73,10.42-3.18l1.24,5.31c1.82-1.49,3.49-3.5,3.36-5.77a4.44,4.44,0,0,0-.67-2"
            fill="#68c902"
          />
          <path
            d="M396.58,273.46a16.16,16.16,0,0,0-5.15-5.16l11.21-1.37L398,265.3A60.41,60.41,0,0,0,425.42,263,54.08,54.08,0,0,0,412.7,260a20.28,20.28,0,0,1,14.35-3c3.43.57,7.81,1.67,9.71-1.05l6.57,2c.68-1-.41-2.24-1.44-2.94-8.48-5.77-19.66-7.37-30-5.72S392,255.54,383.55,261.3a14,14,0,0,0-3.79,3.37c-2.05,3-5.74,14.29.77,14.65,3.81.22,3.2-3.69,5.15-5C386.39,273.87,395.88,272.36,396.58,273.46Z"
            fill="#68c902"
          />
          <path
            d="M62.5,101.14a7.48,7.48,0,0,0,3.23-3.47,7.61,7.61,0,0,0,8.58,1.62,6.65,6.65,0,0,0,3.62-7.47l3.47,10.56c6.35-7.35,15-15.5,24.85-13.24-4.45-.63-9.06,2.86-9.32,7.07a15.6,15.6,0,0,1,11,.59,4.69,4.69,0,0,0,3-2.57c1.12,2.45,5.55,1.52,6.64-1s0-5.26-1.08-7.73a27.88,27.88,0,0,1,10.83,12.24L134,93.88c-1.51,1.34,2.16,2.38,3.89,1.3s5.37-1,4.46.79A79.6,79.6,0,0,1,148,78.07a32,32,0,0,0,2.87,16.33,6.31,6.31,0,0,0,2.81-2.88c-.12,1.24,1.58,1.85,2.9,2a54,54,0,0,0,36.58-9.23l-4.63,7.84a40.77,40.77,0,0,1,23.08-2.69l.21-6.1,11.95,5.32,3-3.68a24.44,24.44,0,0,0,5.76,5.81c-2.58,4-8.4,4.78-13.43,5.07q-28,1.56-56.1,2.2c-22.28.5-44.77.63-66.74,4.54-10.61,1.89-21.26,7.62-31.6,9-9.54,1.29-13.33-7.48-9.27-15.41A16.22,16.22,0,0,1,62.5,101.14Z"
            fill="#68c902"
          />
          <path
            d="M241.61,85.28c1,.16,1.92.63,2.9.88,5.6,1.42,10.11-4.23,12.79-9l2.19,2.83a3.86,3.86,0,0,0,3-1.09l8.38,5.55A10,10,0,0,0,280.27,80c.06,3.2,4.65,4.63,7.92,3.67s5.92-3.28,9.19-4.23,7.85.5,7.9,3.7L309,81.52c-1.11.64.56,2.06,1.86,2a10.47,10.47,0,0,0,9.31-6l5.56,5.78,4.09-2.56a7.87,7.87,0,0,0,3.61,4.07,20.38,20.38,0,0,1,9.52-11,31.27,31.27,0,0,0-3.61,12l4.16-3.13c2.61,2.13,1.29,6.49-1.61,8.26s-6.62,1.71-10.09,1.6q-30.29-.91-60.59-.06c-8.81.25-19.71,2.53-28.33,1.3-2.86-.41-5,.74-6.38-2.43C235.27,88.48,238.12,84.71,241.61,85.28Z"
            fill="#68c902"
          />
          <path
            d="M475.52,119.82l-4,1.08-1.58-2.3c.25,1.24-1.7,2-2.86,1.38a4.46,4.46,0,0,1-1.8-3.26,24.8,24.8,0,0,1,.06-9.25,19.26,19.26,0,0,0-4.92,8l-1.26-2.33-2.15,1c-2.46.12-4.53-3.1-6.74-2.08-.53.24-.93.71-1.5.85a3,3,0,0,1-2.39-.87,23.87,23.87,0,0,0-12.43-4.39c4.11,6.53,11.67,10.36,19,13.52,5.26,2.26,30.46,14.91,29.73.84-1.14,1.09-3.59,1.5-4.82,2.42C477.66,124.19,475.1,119.93,475.52,119.82Z"
            fill="#68c902"
          />
        </g>
        <path
          d="M175.73,343.15c-5.22,4.5,7,19.62,14.23,16.79S178.73,340.56,175.73,343.15Z"
          fill="url(#e3556062-ecd6-426e-9982-a26eedcc2b41)"
        />
      </g>
      <g id="b999249c-4b2a-43fd-a9ba-12421598b779" data-name="tech">
        <g>
          <path
            d="M222.37,252.33a1.41,1.41,0,0,1,.75.23.87.87,0,0,1,.29.57,7,7,0,0,1,.06.9,6.72,6.72,0,0,1-.12,1.26.64.64,0,0,1-.74.59q-.41,0-1.23-.09c-.55-.06-1.22-.1-2-.11-.06.64-.09,1.28-.11,1.92s0,1.28,0,1.94c0,.82,0,1.61.05,2.36s.07,1.42.12,2,.09,1.07.12,1.45.05.61.05.69a.72.72,0,0,1-.15.51.9.9,0,0,1-.52.23l-.94.1c-.32,0-.64,0-1,0h-.24l-.25,0a1.49,1.49,0,0,1-.72-.26.85.85,0,0,1-.36-.68c-.09-1-.16-2-.21-3s-.07-2-.07-3.05c0-.69,0-1.39,0-2.09s.06-1.41.11-2.13c-.71,0-1.32.06-1.84.1s-.87.06-1.08.06a.79.79,0,0,1-.58-.18,1.21,1.21,0,0,1-.17-.76c0-.31,0-.63,0-1a3.67,3.67,0,0,1,.14-.84.8.8,0,0,1,.33-.48,1.32,1.32,0,0,1,.57-.17c.75-.06,1.55-.1,2.42-.14s1.75-.05,2.66-.05l2.31,0C220.88,252.27,221.63,252.29,222.37,252.33Z"
            fill="#fff"
          />
          <path
            d="M231.06,261.9a11.15,11.15,0,0,1-1.25.35c-.49.11-1,.2-1.56.28s-1.12.16-1.71.22-1.16.11-1.71.13a3.08,3.08,0,0,0,1.06.75,3.46,3.46,0,0,0,1.35.27,6.19,6.19,0,0,0,1.25-.15,5.68,5.68,0,0,0,1.3-.44,1.61,1.61,0,0,1,.43-.14.28.28,0,0,1,.25.11,1.36,1.36,0,0,1,.16.34,4.29,4.29,0,0,1,.13.44,3.58,3.58,0,0,1,.09.45.64.64,0,0,1,0,.22v.19a.93.93,0,0,1-.32.7,4.29,4.29,0,0,1-1.73.94,8,8,0,0,1-2.49.36,5.1,5.1,0,0,1-1.93-.37,4.79,4.79,0,0,1-1.63-1,5.22,5.22,0,0,1-1.14-1.61,5.05,5.05,0,0,1-.43-2.1,5.22,5.22,0,0,1,.44-2.14,5.36,5.36,0,0,1,1.18-1.68,5.24,5.24,0,0,1,1.7-1.1,5.56,5.56,0,0,1,2-.38,5.08,5.08,0,0,1,2.38.51,4.85,4.85,0,0,1,1.55,1.24,5,5,0,0,1,.83,1.53,4.59,4.59,0,0,1,.26,1.35,1.14,1.14,0,0,1-.1.45A.77.77,0,0,1,231.06,261.9Zm-4.45-2.59a2.32,2.32,0,0,0-2.16,1.51l1.94-.12a12.45,12.45,0,0,0,1.87-.29,1.52,1.52,0,0,0-.7-.84A2,2,0,0,0,226.61,259.31Z"
            fill="#fff"
          />
          <path
            d="M238.38,256.52a8.44,8.44,0,0,1,1,.06,4.53,4.53,0,0,1,1,.26,1.72,1.72,0,0,1,.67.43,1.51,1.51,0,0,1,.27.82c0,.22,0,.42.06.62s0,.39,0,.58a8.36,8.36,0,0,1-.12,1.43,1.19,1.19,0,0,1-.23.58.87.87,0,0,1-.59.15,6,6,0,0,1-1.1-.08,1.07,1.07,0,0,1-.92-1q0-.29-.06-.6c0-.21,0-.42,0-.62a3.65,3.65,0,0,0-1,.24,3.4,3.4,0,0,0-.87.52,2.48,2.48,0,0,0-.58.75,2.09,2.09,0,0,0-.21.94,2.61,2.61,0,0,0,.16.91,2.37,2.37,0,0,0,.47.76,2.14,2.14,0,0,0,.75.52,2.4,2.4,0,0,0,1,.19,3.26,3.26,0,0,0,.58-.06,4.71,4.71,0,0,0,.62-.16c.2-.07.39-.14.57-.22a3.22,3.22,0,0,0,.45-.21l.38-.17a.6.6,0,0,1,.27-.07c.18,0,.34.13.49.38l.25.47c.08.17.15.34.22.51l.1.34a.93.93,0,0,1,0,.27.88.88,0,0,1-.32.6,4.3,4.3,0,0,1-.74.48,6.82,6.82,0,0,1-.94.37,7.32,7.32,0,0,1-1,.26,6.44,6.44,0,0,1-1.07.09,8,8,0,0,1-2.21-.27,5.86,5.86,0,0,1-1.57-.72,3.78,3.78,0,0,1-1-1,5.1,5.1,0,0,1-.6-1.12,4.63,4.63,0,0,1-.29-1.07,6.05,6.05,0,0,1-.07-.88,4.3,4.3,0,0,1,.53-2.12,5.45,5.45,0,0,1,1.41-1.69,6.63,6.63,0,0,1,2-1.12A7,7,0,0,1,238.38,256.52Z"
            fill="#fff"
          />
          <path
            d="M243.46,253.5a4.1,4.1,0,0,1,.09-.79.59.59,0,0,1,.48-.42c.17,0,.36-.07.57-.1l.68-.07.69-.05.59,0c.22,0,.36,0,.41.15a1,1,0,0,1,.08.42c0,.12,0,.36,0,.71s0,.76,0,1.22,0,.94,0,1.47,0,1,0,1.48a5.21,5.21,0,0,1,1.58-.79,6,6,0,0,1,1.74-.25,5.93,5.93,0,0,1,1,.09,2.81,2.81,0,0,1,1,.39,2.25,2.25,0,0,1,.83.87,3.17,3.17,0,0,1,.34,1.56q0,.56,0,1.29c0,.49,0,1-.09,1.58s-.08,1.15-.14,1.76-.13,1.22-.21,1.82a1.77,1.77,0,0,1-.2.64c-.1.2-.33.3-.68.3-.19,0-.46,0-.8-.05a8.54,8.54,0,0,1-1-.16.8.8,0,0,1-.66-.89q0-.23.12-1.53c.07-.87.11-2,.11-3.49a1.42,1.42,0,0,0-.2-.79.66.66,0,0,0-.58-.29,4.05,4.05,0,0,0-2.18.75q0,1.57.06,2.94c0,.91.07,1.67.14,2.28a1,1,0,0,1,0,.23,1.34,1.34,0,0,1,0,.2.66.66,0,0,1-.21.53,1.6,1.6,0,0,1-.87.23l-.31,0h-.71l-.3,0a1.16,1.16,0,0,1-.83-.29,1.45,1.45,0,0,1-.25-.73c-.05-.43-.09-.92-.14-1.5s-.08-1.21-.12-1.9-.06-1.4-.08-2.15,0-1.51,0-2.29,0-1.49.05-2.22S243.43,254.19,243.46,253.5Z"
            fill="#fff"
          />
          <path
            d="M254.86,257.88a4.82,4.82,0,0,1,.1-.78.56.56,0,0,1,.48-.42,5.49,5.49,0,0,1,.57-.1l.67-.07.69-.05c.24,0,.43,0,.6,0s.34,0,.4.14a.62.62,0,0,1,.11.39,2.29,2.29,0,0,1,0,.25,1.69,1.69,0,0,1,0,.3,5.77,5.77,0,0,1,1.61-.8,5.64,5.64,0,0,1,1.74-.26,5.93,5.93,0,0,1,1,.09,2.88,2.88,0,0,1,1,.39,2.32,2.32,0,0,1,.83.87,3.17,3.17,0,0,1,.33,1.56q0,.56,0,1.29c0,.49-.05,1-.08,1.58s-.08,1.15-.14,1.76-.14,1.22-.22,1.82a1.76,1.76,0,0,1-.19.64c-.1.2-.33.3-.68.3s-.48,0-.81-.05a9,9,0,0,1-1-.16.8.8,0,0,1-.65-.89c0-.15,0-.34,0-.56s0-.53.08-.91.06-.86.08-1.43,0-1.28,0-2.12a1.42,1.42,0,0,0-.19-.79.66.66,0,0,0-.58-.29,3.33,3.33,0,0,0-1.08.19,5,5,0,0,0-1.17.6c0,.89,0,1.76.07,2.61s.12,1.72.2,2.57c0,.09,0,.16,0,.23a1.34,1.34,0,0,1,0,.2.66.66,0,0,1-.21.53,1.66,1.66,0,0,1-.87.23l-.32,0h-.7l-.31,0a1.15,1.15,0,0,1-.82-.29,1.45,1.45,0,0,1-.26-.73c-.11-1-.2-2.09-.26-3.15s-.11-2.14-.11-3.2v-.73C254.84,258.37,254.85,258.13,254.86,257.88Z"
            fill="#fff"
          />
          <path
            d="M273.22,256.66a2,2,0,0,1,.42.21.53.53,0,0,1,.16.44,1.37,1.37,0,0,1,0,.16,2,2,0,0,1,0,.31,4.39,4.39,0,0,1,2.5,1.55,4.85,4.85,0,0,1,.43,4.93,4.88,4.88,0,0,1-1.25,1.52,5.55,5.55,0,0,1-1.75.93,6.21,6.21,0,0,1-2,.31,8.55,8.55,0,0,1-2.4-.32,5,5,0,0,1-1.84-1,4.31,4.31,0,0,1-1.16-1.59,5.54,5.54,0,0,1-.41-2.18,5,5,0,0,1,.51-2.27,5.38,5.38,0,0,1,1.33-1.74,6.18,6.18,0,0,1,1.84-1.12,5.9,5.9,0,0,1,2.09-.39,5.52,5.52,0,0,1,.77.06A5.65,5.65,0,0,1,273.22,256.66Zm-.63,3.92-.4-.16a.76.76,0,0,1-.25-.18.61.61,0,0,1-.15-.3,1.59,1.59,0,0,1-.06-.49,2.7,2.7,0,0,0-1.73.83,2.52,2.52,0,0,0-.69,1.81,1.91,1.91,0,0,0,.17.8,1.77,1.77,0,0,0,.48.6,2,2,0,0,0,.7.37,3,3,0,0,0,.85.12,3.06,3.06,0,0,0,.85-.12,2.19,2.19,0,0,0,.75-.37,1.72,1.72,0,0,0,.54-.6,1.57,1.57,0,0,0,.21-.8,1.37,1.37,0,0,0-.35-1A2,2,0,0,0,272.59,260.58Z"
            fill="#fff"
          />
          <path
            d="M278.71,253.5a2.39,2.39,0,0,1,.19-.91.68.68,0,0,1,.42-.3,7.59,7.59,0,0,1,1.08-.18q.62-.06,1.05-.06a.54.54,0,0,1,.44.16,1,1,0,0,1,.15.64c0,.31,0,.63,0,1s0,.67,0,1c0,.94,0,1.91,0,2.92s0,2-.08,2.95-.06,1.86-.1,2.69-.09,1.55-.14,2.15a2.85,2.85,0,0,1-.17.84c-.09.19-.35.31-.79.35l-.24,0H280l-.32,0a1.18,1.18,0,0,1-.83-.29,1.37,1.37,0,0,1-.23-.73c-.06-.62-.1-1.37-.12-2.26s0-1.86,0-2.9,0-2.35.07-3.56S278.6,254.6,278.71,253.5Z"
            fill="#fff"
          />
          <path
            d="M290.66,256.66a2,2,0,0,1,.42.21.5.5,0,0,1,.16.44s0,.09,0,.16,0,.16-.05.31a4.36,4.36,0,0,1,2.49,1.55,4.85,4.85,0,0,1,.43,4.93,4.88,4.88,0,0,1-1.25,1.52,5.55,5.55,0,0,1-1.75.93,6.2,6.2,0,0,1-1.94.31,8.57,8.57,0,0,1-2.41-.32,5,5,0,0,1-1.84-1,4.31,4.31,0,0,1-1.16-1.59,5.54,5.54,0,0,1-.41-2.18,5,5,0,0,1,.51-2.27,5.38,5.38,0,0,1,1.33-1.74,6.18,6.18,0,0,1,1.84-1.12,5.91,5.91,0,0,1,2.1-.39,5.38,5.38,0,0,1,.76.06A5.65,5.65,0,0,1,290.66,256.66Zm-.63,3.92-.4-.16a.76.76,0,0,1-.25-.18.61.61,0,0,1-.15-.3,1.63,1.63,0,0,1-.05-.49,2.71,2.71,0,0,0-1.74.83,2.52,2.52,0,0,0-.69,1.81,1.91,1.91,0,0,0,.17.8,1.77,1.77,0,0,0,.48.6,1.93,1.93,0,0,0,.71.37,2.84,2.84,0,0,0,.84.12,3.06,3.06,0,0,0,.85-.12,2.19,2.19,0,0,0,.75-.37,1.72,1.72,0,0,0,.54-.6,1.57,1.57,0,0,0,.21-.8,1.37,1.37,0,0,0-.35-1A2,2,0,0,0,290,260.58Z"
            fill="#fff"
          />
          <path
            d="M305.82,269.37a2.27,2.27,0,0,1-.35.86,2.82,2.82,0,0,1-.71.71,3.52,3.52,0,0,1-1,.49,4,4,0,0,1-1.23.18,11.25,11.25,0,0,1-5-1,1.93,1.93,0,0,1-.48-.33.68.68,0,0,1-.19-.5,2.51,2.51,0,0,1,.18-.79c.12-.33.25-.63.37-.91a1.17,1.17,0,0,1,.24-.33.43.43,0,0,1,.31-.12,1.35,1.35,0,0,1,.51.13,10.33,10.33,0,0,0,1.89.46c.57.07,1.22.11,1.92.13.07-.42.13-.87.19-1.34s.1-1,.14-1.46a4.88,4.88,0,0,1-3.08,1.06,4.68,4.68,0,0,1-1.76-.31,3.85,3.85,0,0,1-1.31-.87,3.76,3.76,0,0,1-.83-1.3,4.56,4.56,0,0,1-.28-1.62,5.42,5.42,0,0,1,.5-2.33,6.06,6.06,0,0,1,1.32-1.89,6.32,6.32,0,0,1,1.87-1.25,5.19,5.19,0,0,1,2.14-.46,4.75,4.75,0,0,1,1.49.22.84.84,0,0,1,.15-.42.53.53,0,0,1,.36-.11,8.64,8.64,0,0,1,.88.08,8.83,8.83,0,0,1,1.14.23,3.11,3.11,0,0,1,.43.14.84.84,0,0,1,.3.22,1,1,0,0,1,.2.37,2.22,2.22,0,0,1,.09.59c0,.37.05.82.06,1.34s0,1.1,0,1.72,0,1.45,0,2.23-.05,1.53-.09,2.28-.1,1.46-.16,2.14S305.92,268.85,305.82,269.37Zm-3-6.63c0-.41,0-.81,0-1.2v-2a2.64,2.64,0,0,0-.54-.16,4.16,4.16,0,0,0-.64-.05,2.18,2.18,0,0,0-1.09.27,2.73,2.73,0,0,0-.81.65,3.17,3.17,0,0,0-.5.85,2.46,2.46,0,0,0-.17.84,1.57,1.57,0,0,0,.47,1.18,1.84,1.84,0,0,0,1.3.44A3,3,0,0,0,302.82,262.74Z"
            fill="#fff"
          />
          <path
            d="M317.59,269.37a2.33,2.33,0,0,1-.3.86,2.5,2.5,0,0,1-.67.71,3.53,3.53,0,0,1-1,.49,4.08,4.08,0,0,1-1.24.18,12.46,12.46,0,0,1-2.64-.25,11.69,11.69,0,0,1-2.36-.79,1.57,1.57,0,0,1-.45-.31.67.67,0,0,1-.18-.46,1.3,1.3,0,0,1,.06-.32c0-.14.09-.3.15-.47s.13-.34.21-.52a3.14,3.14,0,0,1,.23-.45,1.72,1.72,0,0,1,.26-.33.37.37,0,0,1,.29-.12,1,1,0,0,1,.23,0l.28.09c.34.1.66.2.95.27s.58.14.86.19.56.08.85.1.59,0,.93,0a20.9,20.9,0,0,0,.31-2.84,5.73,5.73,0,0,1-1.64.82,6,6,0,0,1-1.79.26,6,6,0,0,1-1-.09,2.86,2.86,0,0,1-1-.38,2.36,2.36,0,0,1-.82-.84,2.87,2.87,0,0,1-.34-1.5c0-.35,0-.77,0-1.25s.05-1,.08-1.53.09-1.1.15-1.69.13-1.17.21-1.75a.91.91,0,0,1,.42-.75,2.29,2.29,0,0,1,1-.17,4,4,0,0,1,.69,0,2.91,2.91,0,0,1,.63.15.85.85,0,0,1,.66.88c0,.13,0,.37-.05.69s-.08.71-.12,1.16-.08.92-.11,1.43-.05,1-.05,1.55a1.32,1.32,0,0,0,.19.76.67.67,0,0,0,.59.29,3.92,3.92,0,0,0,1.11-.19,4.26,4.26,0,0,0,1.19-.59c0-.5,0-1-.07-1.59s-.07-1.08-.11-1.56-.08-.89-.12-1.23-.05-.54-.05-.62a.85.85,0,0,1,.23-.63,1.94,1.94,0,0,1,.83-.39,5.74,5.74,0,0,1,.59-.11,3.44,3.44,0,0,1,.62,0,1.85,1.85,0,0,1,.84.15c.2.1.32.34.36.73s.08.79.11,1.29.07,1,.11,1.62.05,1.2.07,1.85,0,1.3,0,2c0,.92,0,1.83,0,2.72S317.69,268.63,317.59,269.37Z"
            fill="#fff"
          />
          <path
            d="M326.18,266.61a.72.72,0,0,1-.45-.2.7.7,0,0,1-.2-.35,2.12,2.12,0,0,1,0-.42v-.39a8.13,8.13,0,0,1,0-.84c0-.28.06-.56.1-.81a.85.85,0,0,1,.15-.36.42.42,0,0,1,.34-.13,1.3,1.3,0,0,1,.29,0l.34.08.68.09a9.48,9.48,0,0,0,1,.05,9.34,9.34,0,0,0,1.18-.07,5.69,5.69,0,0,0,1.05-.22,2.4,2.4,0,0,0,.75-.4.76.76,0,0,0,.28-.59c0-.19-.2-.34-.59-.45s-.88-.22-1.47-.33-1.22-.24-1.92-.41a8,8,0,0,1-1.92-.71,4.59,4.59,0,0,1-1.46-1.23,3.16,3.16,0,0,1-.59-2,3.59,3.59,0,0,1,.66-2.16,5.24,5.24,0,0,1,1.73-1.49,8.94,8.94,0,0,1,2.43-.85,13.27,13.27,0,0,1,2.74-.28l.74,0,.73.06.1-.49a1,1,0,0,1,.18-.3.45.45,0,0,1,.37-.17,7.46,7.46,0,0,1,2.13.29.8.8,0,0,1,.46.33.78.78,0,0,1,.11.36c0,.49-.06.94-.08,1.34s-.07.78-.11,1.12-.08.68-.14,1-.11.66-.16,1a.86.86,0,0,1-.22.46.67.67,0,0,1-.54.19,10.63,10.63,0,0,1-1.07,0,5.64,5.64,0,0,1-.91-.16.48.48,0,0,1-.34-.27.88.88,0,0,1-.12-.44V256c0-.17,0-.33,0-.49l-.79-.09H331a7.6,7.6,0,0,0-1.21.08,5.68,5.68,0,0,0-1,.22,1.86,1.86,0,0,0-.64.37.65.65,0,0,0-.23.49c0,.27.18.47.56.6a10.59,10.59,0,0,0,1.39.36l1.83.39a7.31,7.31,0,0,1,1.83.7,4.13,4.13,0,0,1,1.39,1.24,3.47,3.47,0,0,1,.56,2.07A3.94,3.94,0,0,1,335,264a4.69,4.69,0,0,1-1.44,1.54,6.57,6.57,0,0,1-2.18,1,10.62,10.62,0,0,1-2.72.33A14.52,14.52,0,0,1,326.18,266.61Z"
            fill="#fff"
          />
          <path
            d="M337.44,253.5a4.21,4.21,0,0,1,.12-.88.63.63,0,0,1,.45-.33c.17,0,.36-.07.57-.1l.68-.07.69-.05.59,0c.22,0,.36,0,.41.15a.83.83,0,0,1,.08.42c0,.27,0,1-.06,2.33s-.06,3.14-.06,5.59c.52-.78,1-1.5,1.56-2.17s1.08-1.3,1.66-1.89a3,3,0,0,1,.35-.31.65.65,0,0,1,.39-.12.93.93,0,0,1,.51.16,5,5,0,0,1,1.28,1.08,1.07,1.07,0,0,1,.29.66,1.22,1.22,0,0,1-.35.73,11.9,11.9,0,0,1-1.14,1.2c-.48.45-.94.87-1.39,1.27l.53-.06a4.52,4.52,0,0,1,.51,0,3.54,3.54,0,0,1,.47,0l.45.06a1.28,1.28,0,0,1,1,.61,3.07,3.07,0,0,1,.28,1.45,8.44,8.44,0,0,1-.12,1.27c-.07.51-.16,1-.25,1.34a2,2,0,0,1-.29.71.68.68,0,0,1-.59.23,6.74,6.74,0,0,1-.93-.08,8.83,8.83,0,0,1-1.05-.25.69.69,0,0,1-.31-.19.58.58,0,0,1-.16-.44s0-.09,0-.15a1.6,1.6,0,0,1,.07-.28,5,5,0,0,0,.17-.83,8,8,0,0,0,.06-1l-.58-.09a6.3,6.3,0,0,0-.79-.05,6.81,6.81,0,0,0-.78.05,3.92,3.92,0,0,0-.77.18c0,.25,0,.51,0,.77s0,.5.06.71,0,.41.05.57a2.09,2.09,0,0,1,0,.29.66.66,0,0,1-.21.53,1.6,1.6,0,0,1-.87.23l-.31,0h-.71l-.3,0a1.18,1.18,0,0,1-.83-.29,1.45,1.45,0,0,1-.25-.73c0-.43-.09-.93-.13-1.51s-.09-1.23-.13-1.92-.06-1.42-.08-2.17,0-1.52,0-2.3,0-1.49,0-2.22S337.39,254.15,337.44,253.5Z"
            fill="#fff"
          />
          <path
            d="M350.6,251.89a4.57,4.57,0,0,1,1,.08,1.36,1.36,0,0,1,.65.31,1.43,1.43,0,0,1,.37.65,4,4,0,0,1,.11,1.08,2.73,2.73,0,0,1-.09.72,1.32,1.32,0,0,1-.32.58,1.38,1.38,0,0,1-.64.38,3.49,3.49,0,0,1-1,.13,4.35,4.35,0,0,1-1-.09,1.24,1.24,0,0,1-.62-.33,1.3,1.3,0,0,1-.34-.61,3.7,3.7,0,0,1-.1-1,2,2,0,0,1,.46-1.45A2.11,2.11,0,0,1,350.6,251.89Zm-1.67,6.16a2.8,2.8,0,0,1,.12-.79.57.57,0,0,1,.51-.38,5.37,5.37,0,0,1,.79-.11l.86,0h.35l.33,0c.2,0,.33.07.37.18a1.67,1.67,0,0,1,.08.64c0,1.45,0,2.82-.06,4.09s-.09,2.59-.19,3.95c0,.2,0,.37,0,.51a.7.7,0,0,1-.14.35.65.65,0,0,1-.32.2,2.22,2.22,0,0,1-.59.06,10.23,10.23,0,0,1-1.12-.06,1.1,1.1,0,0,1-.81-.32,1.47,1.47,0,0,1-.21-.76c0-.5-.05-1-.07-1.46s0-1,0-1.44c0-.78,0-1.55.05-2.31S348.87,258.85,348.93,258.05Z"
            fill="#fff"
          />
          <path
            d="M354.48,253.5a2.68,2.68,0,0,1,.18-.91.7.7,0,0,1,.43-.3,7.13,7.13,0,0,1,1.08-.18c.41,0,.76-.06,1-.06a.56.56,0,0,1,.45.16,1.06,1.06,0,0,1,.14.64c0,.31,0,.63,0,1s0,.67,0,1c0,.94,0,1.91,0,2.92s0,2-.07,2.95-.06,1.86-.1,2.69-.09,1.55-.14,2.15a2.52,2.52,0,0,1-.18.84c-.09.19-.35.31-.78.35l-.25,0h-.56l-.31,0a1.16,1.16,0,0,1-.83-.29,1.29,1.29,0,0,1-.23-.73c-.06-.62-.1-1.37-.13-2.26s0-1.86,0-2.9,0-2.35.07-3.56S354.37,254.6,354.48,253.5Z"
            fill="#fff"
          />
          <path
            d="M359.86,253.5a2.39,2.39,0,0,1,.19-.91.68.68,0,0,1,.42-.3,7.5,7.5,0,0,1,1.09-.18c.4,0,.75-.06,1-.06a.54.54,0,0,1,.44.16,1,1,0,0,1,.15.64c0,.31,0,.63,0,1s0,.67,0,1c0,.94,0,1.91,0,2.92s-.05,2-.07,2.95-.07,1.86-.11,2.69-.08,1.55-.14,2.15a2.56,2.56,0,0,1-.17.84c-.09.19-.35.31-.79.35l-.24,0h-.56l-.32,0a1.18,1.18,0,0,1-.83-.29,1.37,1.37,0,0,1-.23-.73c-.05-.62-.1-1.37-.12-2.26s0-1.86,0-2.9,0-2.35.07-3.56S359.75,254.6,359.86,253.5Z"
            fill="#fff"
          />
          <path
            d="M372.51,263.9a2.33,2.33,0,0,1-.35,1.25,3.12,3.12,0,0,1-.94.94,4.91,4.91,0,0,1-1.43.62,7.26,7.26,0,0,1-1.79.21,10.22,10.22,0,0,1-1.54-.11,6.62,6.62,0,0,1-1.29-.36.7.7,0,0,1-.55-.67,1.84,1.84,0,0,1,.06-.43,4,4,0,0,1,.23-.62l.26-.6c.13-.29.27-.43.42-.43a1.57,1.57,0,0,1,.53.16,3.85,3.85,0,0,0,.81.27,4.26,4.26,0,0,0,.73.08,2.52,2.52,0,0,0,.75-.1.39.39,0,0,0,.29-.39c0-.15-.11-.29-.32-.41a6.58,6.58,0,0,0-.79-.38l-1-.45a5.39,5.39,0,0,1-1-.63,3.32,3.32,0,0,1-.78-.92,2.54,2.54,0,0,1-.32-1.31,2.34,2.34,0,0,1,.4-1.34,3.49,3.49,0,0,1,1-1,5.47,5.47,0,0,1,1.47-.65,6.07,6.07,0,0,1,1.7-.24,8.61,8.61,0,0,1,1.5.13,7.76,7.76,0,0,1,1.4.34,1.06,1.06,0,0,1,.5.32,1,1,0,0,1,.17.62,6.14,6.14,0,0,1-.09,1c-.06.37-.12.68-.19.94a1.54,1.54,0,0,1-.26.48.75.75,0,0,1-.56.17,6.23,6.23,0,0,1-1.22-.12.9.9,0,0,1-.52-.23,1.13,1.13,0,0,1-.12-.63v-.14a2.71,2.71,0,0,0-.65-.1,2.56,2.56,0,0,0-.89.14.51.51,0,0,0-.35.49c0,.15.11.29.34.41a8.84,8.84,0,0,0,.88.38c.36.12.74.27,1.14.44a5.63,5.63,0,0,1,1.15.64,3.31,3.31,0,0,1,.87.92A2.51,2.51,0,0,1,372.51,263.9Z"
            fill="#fff"
          />
        </g>
      </g>
      <g id="bf5239ea-b485-4940-bef5-432bd02e9ffb" data-name="flag tech">
        <g>
          <ellipse cx="90.88" cy="162.09" rx="19.21" ry="9.36" fill="#55a32a" />
          <path
            d="M96.85,167c0,3.17-6.32,5.74-14.12,5.74S68.61,170.21,68.61,167c0-.66.06-2.58.06-2.58s7.89-3.16,14.06-3.16,14.09,3.11,14.09,3.11S96.85,166.35,96.85,167Z"
            fill="#8abcf8"
          />
          <ellipse cx="82.73" cy="164.64" rx="14.12" ry="5.74" fill="#9ae1f8" />
          <path
            d="M82.28,163.21c1.16,1,11.57-2.3,11.57-2.3s-3.89-1.33-4.59-1.49a43.68,43.68,0,0,0-8.14,2.29Z"
            fill="#8aa6f8"
          />
          <path
            d="M82.92,163.81H80.63V19.86L82.72,0l2.12,19.86V162.05A1.85,1.85,0,0,1,82.92,163.81Z"
            fill="#9ae1f8"
          />
          <path
            d="M82.72,0l-1,9.14L82.92,20V163.81h0a1.85,1.85,0,0,0,1.92-1.76V19.86Z"
            fill="#8abcf8"
          />
          <path
            d="M113.93,44.44,51.58,54.79a1.6,1.6,0,0,1-1.85-1.18l-.07-.38a1.48,1.48,0,0,1,1.28-1.7l62.34-10.35a1.58,1.58,0,0,1,1.85,1.18l.08.38A1.49,1.49,0,0,1,113.93,44.44Z"
            fill="#9ae1f8"
          />
          <path
            d="M59.59,53.49s6,12.14,7.22,19.87-5.41,28.12,0,43,29.44,25.37,29.44,25.37l12.62-20.41L140.72,128s-16.23-11-18.63-25.92,0-33.65-3-41.92-10.23-14.9-10.23-14.9Z"
            fill="#fff205"
          />
          <path
            d="M59.29,50.14a2.13,2.13,0,0,1,.31,3.36c6.85-1.11,16.82-2.76,16.82-2.76a2,2,0,0,0-.6-3.31C70.3,48.16,59.29,50.14,59.29,50.14Z"
            fill="#d1fa73"
          />
          <path
            d="M92,44.62A2.14,2.14,0,0,1,92.35,48l16.82-2.75a2,2,0,0,0-.6-3.31C103.05,42.64,92,44.62,92,44.62Z"
            fill="#d1fa73"
          />
          <path
            d="M80.63,19.86v9.76a4.57,4.57,0,0,0,2.62.52c.41,0,1.18-.21,1.59-.24v-10L82.72,0Z"
            fill="#cfdff1"
          />
          <path
            d="M115.87,107c2.61-.28,5.06-.48,7.33-.62a25.47,25.47,0,0,1-1.11-4.33c-2.4-14.9,0-33.65-3-41.92-.14-.37-.29-.74-.44-1.1-4.32,4.39-21.26,13.19-31.82,15.06-10,1.77-15.69,3.79-20.77,11.18-1.19,9.36-2.77,21.41.75,31.12a23.13,23.13,0,0,0,1.3,2.88C79.25,118.81,104,108.28,115.87,107Z"
            fill="#bacc05"
          />
          <path
            d="M115.21,42.74l-.08-.38a1.58,1.58,0,0,0-1.85-1.18l-.13,0a1.52,1.52,0,0,1,.06.2l.08.38a1.49,1.49,0,0,1-1.28,1.7L49.79,53.81a1.61,1.61,0,0,0,1.79,1l62.35-10.35A1.49,1.49,0,0,0,115.21,42.74Z"
            fill="#9ae1f8"
            opacity="0.5"
            style={{ mixBlendMode: 'multiply' }}
          />
          <path
            d="M82.72,0l-.45,4.27,1.52,14.25L84,28.91a13.72,13.72,0,0,1-1.78.05,8,8,0,0,1-1.59-.26v.92a4.57,4.57,0,0,0,2.62.52c.41,0,1.18-.21,1.59-.24v-10Z"
            fill="#bad2f1"
          />
          <path
            d="M85,29.32c0,.48-1,.88-2.3.88s-2.29-.4-2.29-.88"
            fill="none"
            stroke="#cfdff1"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <g>
            <rect
              x="95.49"
              y="73.84"
              width="11.28"
              height="5.54"
              fill="#18adb1"
            />
            <polygon
              points="95.57 78.99 88.32 88.63 84.51 85.06 91.76 75.42 95.57 78.99"
              fill="#18adb1"
            />
            <polygon
              points="88.24 87.85 90.19 100.24 85.3 101.2 83.34 88.81 88.24 87.85"
              fill="#18adb1"
            />
            <polygon
              points="90.37 99.15 100.14 105.44 97.65 110.25 87.89 103.95 90.37 99.15"
              fill="#18adb1"
            />
            <polygon
              points="99.42 105.34 110.02 101.03 111.72 106.25 101.12 110.55 99.42 105.34"
              fill="#18adb1"
            />
            <polygon
              points="109.08 101.17 112.94 89.35 117.61 91.25 113.75 103.07 109.08 101.17"
              fill="#18adb1"
            />
            <polygon
              points="112.83 89.7 106.44 79.33 110.54 76.19 116.92 86.56 112.83 89.7"
              fill="#18adb1"
            />
            <path
              d="M100.24,76.39c-7.6,0-13.76,6.88-13.76,15.36s6.16,15.35,13.76,15.35S114,100.23,114,91.75,107.84,76.39,100.24,76.39Zm0,24.73c-4.64,0-8.4-4.2-8.4-9.37s3.76-9.37,8.4-9.37,8.4,4.19,8.4,9.37S104.88,101.12,100.24,101.12Z"
              fill="#18adb1"
            />
          </g>
          <g>
            <rect
              x="76.93"
              y="61.78"
              width="5.27"
              height="2.59"
              fill="#18adb1"
            />
            <polygon
              points="76.97 64.19 73.58 68.69 71.8 67.03 75.19 62.52 76.97 64.19"
              fill="#18adb1"
            />
            <polygon
              points="73.54 68.33 74.45 74.12 72.17 74.57 71.25 68.78 73.54 68.33"
              fill="#18adb1"
            />
            <polygon
              points="74.54 73.61 79.1 76.56 77.94 78.8 73.38 75.86 74.54 73.61"
              fill="#18adb1"
            />
            <polygon
              points="78.77 76.51 83.72 74.49 84.52 76.93 79.56 78.94 78.77 76.51"
              fill="#18adb1"
            />
            <polygon
              points="83.28 74.56 85.09 69.03 87.27 69.92 85.47 75.45 83.28 74.56"
              fill="#18adb1"
            />
            <polygon
              points="85.03 69.19 82.05 64.35 83.96 62.88 86.95 67.73 85.03 69.19"
              fill="#18adb1"
            />
            <path
              d="M79.15,63c-3.55,0-6.43,3.21-6.43,7.17s2.88,7.18,6.43,7.18,6.43-3.21,6.43-7.18S82.7,63,79.15,63Zm0,11.55a4.41,4.41,0,1,1,3.93-4.38A4.17,4.17,0,0,1,79.15,74.53Z"
              fill="#18adb1"
            />
          </g>
        </g>
      </g>
      <g id="b467c49d-868a-4356-9a6a-e1301c2afab5" data-name="decor isl 3">
        <g>
          <ellipse cx="449.34" cy="193.7" rx="16.98" ry="8.26" fill="#55a32a" />
          <path
            d="M432.85,196.55c.52,2.57,4.64,5.67,11.08,5.67s10.06-4.39,9.8-6.19-4.9-11.34-4.9-11.34,14.69-3.09,14.18-12.63-1.55-19.59-17.53-21.91-26.55,7-28.09,16.24,2.06,15.21,7.73,17.79a20.81,20.81,0,0,0,10.05,2.06Z"
            fill="#ffe94d"
          />
          <path
            d="M453.73,196c-.24-1.63-4.07-9.62-4.78-11.1a73.17,73.17,0,0,1-13.79,1.37l-2.31,10.25c.52,2.57,4.64,5.67,11.08,5.67S454,197.83,453.73,196Z"
            fill="#ffc74d"
          />
          <path
            d="M435.16,186.3s5.68,5.22,9.93,4.19,3.86-5.56,3.86-5.56S439.91,186.22,435.16,186.3Z"
            fill="#df9078"
          />
          <path
            d="M456.16,154.07c-2.49-1.84-5.92-3.22-10.68-3.92-13.86-2-23.64,4.71-27,12.58,9.61,12,19.28,13.81,32.42,5.72C458.75,163.62,458.72,158.42,456.16,154.07Z"
            fill="#c1d54d"
          />
          <ellipse cx="428.47" cy="170.76" rx="8.08" ry="5.05" fill="#ffffcd" />
          <ellipse cx="430.36" cy="161.82" rx="3.42" ry="2.14" fill="#ffffcd" />
          <ellipse cx="438.89" cy="177.8" rx="3.42" ry="2.14" fill="#ffffcd" />
          <ellipse cx="448.34" cy="158.73" rx="6.54" ry="4.1" fill="#ffffcd" />
          <ellipse cx="452.23" cy="165.78" rx="2.75" ry="1.72" fill="#ffffcd" />
          <path
            d="M463,172.06a42.59,42.59,0,0,0-1.43-10.1c0,3.14-2.94,9-6.05,12.42-6.4,7-20.36,10.83-32.52,8.61a14.5,14.5,0,0,0,2.11,1.19,20.81,20.81,0,0,0,10.05,2.06l0,.13A43,43,0,0,0,449,184.93S463.52,181.6,463,172.06Z"
            fill="#ffc14d"
          />
          <path
            d="M460.21,206.48l-24.92-.27-1.85-.53.9-.24c0-.12-.11-.16-.16-.09a6,6,0,0,1,0-1.22,6.6,6.6,0,0,0,.09-.89.73.73,0,0,1,.1.46,3,3,0,0,1,.13-.74,1.69,1.69,0,0,0,.09-.77,3.92,3.92,0,0,1,.16,2,.81.81,0,0,1,.14-.37v0a6.14,6.14,0,0,0,.21-1.47,2.3,2.3,0,0,1,.22,1.24,5,5,0,0,1,.38-1.64,3.48,3.48,0,0,0,.29-1.75,6.44,6.44,0,0,1,.33,2.85.54.54,0,0,1,.16-.21,1.23,1.23,0,0,0,.31-1,4.66,4.66,0,0,1,.08,1.53c.1-.19.2-.32.29-.53a4.49,4.49,0,0,0,.42-2c0-.21.11-.27.14-.13a6.38,6.38,0,0,1,.12.68,1.37,1.37,0,0,1,.21.91,5.86,5.86,0,0,1,.26-1.5,3.35,3.35,0,0,0,.18-1.56c.16-.08.51,1.59.33,4a1.66,1.66,0,0,1,.29-.77v.09a13.79,13.79,0,0,0,.42-3,4.47,4.47,0,0,1,.44,2.51,11.24,11.24,0,0,1,.78-3.34,7,7,0,0,0,.6-3.55c.29,0,.71,2.36.66,5.79a1.14,1.14,0,0,1,.33-.43,2.43,2.43,0,0,0,.62-1.93,8.65,8.65,0,0,1,.17,3.11c.2-.38.4-.65.59-1.08a9.05,9.05,0,0,0,.86-4.18c0-.42.22-.53.29-.25a13.81,13.81,0,0,1,.12,5.16,18.42,18.42,0,0,1-.49,2.41h.22v0c.14-.27.28-.45.4-.74a5.8,5.8,0,0,0,.55-2.62c0-.27.13-.34.18-.16a8.59,8.59,0,0,1,.07,3.24,2.51,2.51,0,0,1,0,.27l.77,0a1.62,1.62,0,0,1,0-.22,7.57,7.57,0,0,0,.12-1.16.87.87,0,0,1,.15.6,3.63,3.63,0,0,1,.16-1,2.15,2.15,0,0,0,.12-1,5.16,5.16,0,0,1,.21,2.58,1.09,1.09,0,0,1,.19-.5v.06a8.88,8.88,0,0,0,.27-1.93,2.81,2.81,0,0,1,.29,1.62,7,7,0,0,1,.5-2.15,4.56,4.56,0,0,0,.39-2.3c.18,0,.46,1.53.43,3.75a.8.8,0,0,1,.21-.29,1.56,1.56,0,0,0,.4-1.24,5.59,5.59,0,0,1,.11,2,7.59,7.59,0,0,0,.38-.7,6,6,0,0,0,.56-2.7c0-.28.14-.35.18-.17a8.69,8.69,0,0,1,.08,3.34,12.37,12.37,0,0,1-.3,1.52h.15c.08-.17.17-.28.25-.47a3.86,3.86,0,0,0,.35-1.69c0-.18.09-.22.11-.11a5.34,5.34,0,0,1,.05,2.1l0,.22a48.58,48.58,0,0,1,10.1,2.06Zm-22.62-2c0-.11,0-.22,0-.34-.05.21-.1.39-.15.55l.1,0Z"
            fill="#68c902"
          />
        </g>
        <path
          d="M198.31,363.36c-6.94,6,9.28,26.1,18.93,22.34S202.3,359.93,198.31,363.36Z"
          fill="url(#be7dc9d2-26c6-456b-9656-de83e69db48b)"
        />
        <path
          d="M138,279.4c-1,3.47-.21,7.59,2.75,9.87a7.86,7.86,0,0,0-4.76,8.89,8.44,8.44,0,0,0,8.55,5.89,21,21,0,0,0,10.22,19.18c-1.34,9.67,5.82,19.75,15.84,22.29-1,10.79,9.11,21.36,20.63,21.49a115,115,0,0,0,1.7-25.86c2.47,3.41,8.85,2.27,10.84-1.41s.31-8.38-2.81-11.29c7.37-3.58,11.24-11.82,11-19.62C211.28,281.78,150.86,235.59,138,279.4Z"
          fill="#68c902"
        />
        <g>
          <path
            d="M164.12,279.17c-2.23,2.56-6.7,4.62-8.57,3s-.44-6.34,1.8-8.9,4.43-2,6.3-.39S166.36,276.6,164.12,279.17Z"
            fill="#e4f6fb"
          />
          <path
            d="M163.5,289.4c-3.37-.45-7.55-3-7.22-5.51s5-3.86,8.42-3.41,4.13,2.59,3.8,5S166.88,289.85,163.5,289.4Z"
            fill="#e4f6fb"
          />
          <path
            d="M154,293.06c-1.22-3.18-.94-8.09,1.37-9s5.81,2.58,7,5.76-.29,4.87-2.61,5.76S155.24,296.24,154,293.06Z"
            fill="#e4f6fb"
          />
          <path
            d="M147.41,283.11c3-1.57,7.94-1.84,9.08.36s-1.92,6.06-4.94,7.63-4.87.25-6-2S144.39,284.68,147.41,283.11Z"
            fill="#e4f6fb"
          />
          <path
            d="M153.43,274.45c2.79,2,5.3,6.19,3.87,8.22s-6.26,1.09-9.05-.87-2.47-4.2-1-6.23S150.65,272.49,153.43,274.45Z"
            fill="#e4f6fb"
          />
          <circle cx="156.07" cy="282.92" r="3.61" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M209.23,300.61c-2.24,2.57-6.71,4.63-8.58,3s-.44-6.34,1.8-8.91,4.43-2,6.31-.38S211.47,298.05,209.23,300.61Z"
            fill="#e4f6fb"
          />
          <path
            d="M208.61,310.85c-3.38-.46-7.56-3.05-7.23-5.51s5.05-3.86,8.42-3.41,4.13,2.59,3.8,5.05S212,311.3,208.61,310.85Z"
            fill="#e4f6fb"
          />
          <path
            d="M199.13,314.51c-1.22-3.18-.95-8.09,1.37-9s5.8,2.58,7,5.76-.29,4.87-2.61,5.75S200.34,317.69,199.13,314.51Z"
            fill="#e4f6fb"
          />
          <path
            d="M192.52,304.56c3-1.57,7.93-1.85,9.08.36s-1.92,6.06-4.95,7.62-4.86.26-6-2S189.49,306.12,192.52,304.56Z"
            fill="#e4f6fb"
          />
          <path
            d="M198.54,295.89c2.78,2,5.29,6.2,3.86,8.23s-6.26,1.09-9-.87-2.47-4.2-1-6.23S195.75,293.93,198.54,295.89Z"
            fill="#e4f6fb"
          />
          <circle cx="201.17" cy="304.37" r="3.61" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M179.86,340c-1.35,1.55-4,2.79-5.17,1.81s-.27-3.83,1.08-5.38a2.71,2.71,0,0,1,4.09,3.57Z"
            fill="#e4f6fb"
          />
          <path
            d="M179.49,346.21c-2-.27-4.56-1.83-4.36-3.32s3-2.33,5.08-2.06a2.71,2.71,0,0,1-.72,5.38Z"
            fill="#e4f6fb"
          />
          <path
            d="M173.77,348.42c-.74-1.92-.57-4.88.83-5.42s3.5,1.56,4.23,3.48a2.71,2.71,0,0,1-5.06,1.94Z"
            fill="#e4f6fb"
          />
          <path
            d="M169.78,342.42c1.82-.95,4.79-1.12,5.48.22s-1.16,3.65-3,4.6a2.72,2.72,0,0,1-2.5-4.82Z"
            fill="#e4f6fb"
          />
          <path
            d="M173.41,337.19c1.68,1.18,3.2,3.74,2.33,5s-3.77.66-5.45-.52a2.71,2.71,0,0,1,3.12-4.44Z"
            fill="#e4f6fb"
          />
          <circle cx="175" cy="342.3" r="2.17" fill="#feaf26" />
        </g>
        <g>
          <path
            d="M173.86,308.13c-1.5,1.71-4.48,3.09-5.74,2s-.29-4.24,1.21-6,3-1.35,4.21-.26S175.36,306.41,173.86,308.13Z"
            fill="#e4f6fb"
          />
          <path
            d="M173.45,315c-2.26-.3-5.06-2-4.84-3.68s3.38-2.58,5.63-2.28,2.77,1.73,2.55,3.37S175.7,315.27,173.45,315Z"
            fill="#e4f6fb"
          />
          <path
            d="M167.1,317.42c-.81-2.13-.63-5.41.92-6s3.89,1.73,4.7,3.86-.2,3.25-1.75,3.85S167.92,319.55,167.1,317.42Z"
            fill="#e4f6fb"
          />
          <path
            d="M162.68,310.76c2-1,5.31-1.23,6.07.25s-1.28,4.05-3.3,5.1-3.26.17-4-1.31S160.66,311.81,162.68,310.76Z"
            fill="#e4f6fb"
          />
          <path
            d="M166.71,305c1.86,1.31,3.54,4.14,2.58,5.5s-4.18.73-6-.58-1.65-2.81-.69-4.17S164.85,303.66,166.71,305Z"
            fill="#e4f6fb"
          />
          <circle cx="168.47" cy="310.64" r="2.41" fill="#feaf26" />
        </g>
        <path
          d="M116.49,174.92l4.45,6.89a12.66,12.66,0,0,1,.09-4.34l.89,1.77a11.37,11.37,0,0,0,1.84-2.46,8.49,8.49,0,0,0,.62,3.41q2-1.75,3.84-3.63l-.15,3.18a7.63,7.63,0,0,1,4.91-2.92,22.37,22.37,0,0,1,5.84-.12c-1.52-.47-2.88,1-3.76,2.37L130.49,186a7.82,7.82,0,0,1,1-4.07l-1.81,2.28a1.29,1.29,0,0,0-2.1-.7l-1-1a2.1,2.1,0,0,1-2.36,2.16A2.82,2.82,0,0,1,122,182a14.3,14.3,0,0,1-1.79,4.17c-1-1.47-1.61-3.26-2.93-3.84C117.2,180.4,117.59,176.63,116.49,174.92Z"
          fill="#55a32a"
        />
        <path
          d="M382.72,189a10.35,10.35,0,0,1-.13-3.72l1.38,2a4,4,0,0,1,1.56-1.69,9,9,0,0,0,2.32,2.55l1.91-1.53a1.8,1.8,0,0,0,2.3,1.31,5.24,5.24,0,0,0,2.38-1.8l.9,2a6.5,6.5,0,0,0,2.23-1.37,1.92,1.92,0,0,0,.66,1.68A36.19,36.19,0,0,1,409.79,171a51.3,51.3,0,0,0-11.24,23.41,22.75,22.75,0,0,1,7-7.16,1.37,1.37,0,0,0,.07,2,100.45,100.45,0,0,1-7,12,34.67,34.67,0,0,0-3.53-10l-1.62,2.38a3.76,3.76,0,0,1-1.82-1.62,3.43,3.43,0,0,0-1.88-1.55c-.81-.17-1.8.59-1.51,1.37-1.35-1.21-2.67-2.53-4.11-3.6-.19,2.14.42,4.77-.32,6.75-3.28-2.72-3.88-9.87-5.83-13.58C379.57,183.91,381.14,186.47,382.72,189Z"
          fill="#55a32a"
        />
      </g>
      {resources && (
        <g className="resources-wrap" transform="translate(130, 50)">
          <ResourceLink
            r={resources[0]}
            svgComponent={resource1SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[0], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[1]}
            svgComponent={resource2SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[1], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[2]}
            svgComponent={resource3SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[2], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[3]}
            svgComponent={resource4SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[3], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[4]}
            svgComponent={resource5SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[4], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
          <ResourceLink
            r={resources[5]}
            svgComponent={resource6SVGComponent}
            onElementHover={(e) =>
              onElementHover(resources[5], e.target as SVGElement)
            }
            onElementLeave={() => onElementHover()}
            onElementClick={onClick}
          />
        </g>
      )}
    </g>
  );
};
export default TechnologySkillsLink;
